import { Flex } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { useStores } from '../../store/rootStore';
import Container from '../../common/container';
import RegularButton from '../../common/RegularButton';
import PageHeader from '../../common/pageHeader';
import ContinueButton from '../../common/continueButton';
import ProgressBar from '../../common/progressBar';
import BottomSpacer from '../../common/bottomSpacer';
import { WalkingTimeType } from '../../store/walkingTimeStore';
import { trackOnboardingCollectedWalkingTime } from '../../utils/analytics';

export type WalkingTimeOptionType = {
  title: string;
  value: WalkingTimeType;
};

const CollectWalkingTime = observer(() => {
  const { walkingTimeStore, getNextPagePath } = useStores();

  const navigate = useNavigate();

  const handleContinueButtonClick = () => {
    trackOnboardingCollectedWalkingTime(walkingTimeStore.selectedWalkingTime);
    navigate(getNextPagePath('CollectWalkingTime'));
  };

  const handleClick = (selectedWalkingTime: WalkingTimeType) => {
    walkingTimeStore.setWalkingTime(selectedWalkingTime);
  };

  const walkingTimeOptions: WalkingTimeOptionType[] = [
    { title: 'Less than 20 minutes', value: 'lessThanTwentyMin' },
    { title: '20-60 minutes', value: 'twentyToSixtyMinutes' },
    { title: '1-2 hours', value: 'oneToTwoHours' },
    { title: 'More than 2 hours', value: 'twoHoursPlus' },
  ];

  return (
    <Container>
      <ProgressBar currentPage="CollectWalkingTime" />
      <PageHeader title="How much time do you spend walking on a typical day?"></PageHeader>
      <Flex direction={'column'}>
        {walkingTimeOptions.map((option, idx) => (
          <RegularButton
            key={idx}
            title={option.title}
            onClick={() => handleClick(option.value)}
            isSelected={walkingTimeStore.selectedWalkingTime === option.value}
          ></RegularButton>
        ))}
      </Flex>
      <BottomSpacer />
      <ContinueButton
        isDisabled={!walkingTimeStore.selectedWalkingTime}
        onClick={handleContinueButtonClick}
      />
    </Container>
  );
});

export default CollectWalkingTime;
